<template>
  <div class="logo-wrapper">
    <img class="logo-image" src="/logo/artfield-logo-black.png" alt="Artfield Logo" />
  </div>
</template>

<style scoped>
.logo-wrapper {
  border-radius: 100px;
  padding: 4px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.logo-image {
  height: 13px;
  width: auto;
  display: block;
}
</style>
<script setup lang="ts">
</script>